import { useSelector } from "react-redux";
import { useMemo } from "react";
import { State } from "../../../state/store";
import { CareRecipientId } from "../../../domain/care_recipient/CareRecipientId";
import { CareRecipient } from "../../../domain/care_recipient/CareRecipient";
import { CareRecipientName } from "../../../domain/care_recipient/CareRecipientName";
import { CareRecipientHouseId } from "../../../domain/care_recipient/CareRecipientHouseId";
import { CustomerCode } from "../../../domain/care_recipient/CustomerCode";
import { BranchCode } from "../../../domain/care_recipient/BranchCode";

export const useCareRecipientList = (): ReturnType => {
    const jsonArray = useSelector((state: State) => state.careRecipient.careRecipients);
    const processing = useSelector((state: State) => state.careRecipient.processing);

    // 利用者取得一覧の取得はMenus.tsxにて行う

    // コンポーネントでのuseEffect無限ループ対策
    const careRecipients = useMemo(() => (
        jsonArray?.map(it => CareRecipient.from(
            CareRecipientId.fromString(it.id),
            CareRecipientName.fromString(it.name),
            null,
            it.houseId ? CareRecipientHouseId.fromString(it.houseId) : null,
            it.customerCode ? CustomerCode.fromString(it.customerCode) : null,
            it.branchCode ? BranchCode.fromString(it.branchCode) : null,
        )) ?? []
    ), [jsonArray]);

    const isLoading = useMemo(() => processing > 0, [processing]);

    return { careRecipients, isLoading };
};

type ReturnType = {
    careRecipients: CareRecipient[],
    isLoading: boolean
}
